
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import { DossierConfigService } from "../../../services/dossier-config-service";
import AppJournalConfigEdit from "@/components/settings-default/JournalConfigEdit.vue";
import { JournalConfig } from "@/models/dossier-configs/journal-config";
import { PendingChangesNotifier } from "@/utils/pending-changes-notifier";
import { ConfirmResult } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			value: DossierConfigService.getJournalsConfig(),
			toEditJournalId: 0,
			pendingChangesNotifier: null as null | PendingChangesNotifier
		};
	},
	computed: {
		path():IBreadCrumb[] {
			return [
				{
					to: "/settings",
					value: this.$ct("general")
				},
				{
					value: this.$ct("journal-settings")
				}
			] as IBreadCrumb[];
		},
		journalIds():number[] {
			return this.value.getIds();
		},
		pendingChangesWarningText(): string{
			return this.$ct("save-confirm").toString();
		},
	},
	methods: {
		async save() {
			await DossierConfigService.setJournalsConfig(this.value);
			if (this.pendingChangesNotifier){
				this.pendingChangesNotifier.changesPending = false;
			}
			this.$router.push("/settings");
		},
		editJournalName(id:number) {
			this.toEditJournalId = id;
		},
		setJournalConfig(id:number, conf:JournalConfig){
			this.value.setJournalConfig(id, conf);
		}
	},
	created(){
		this.pendingChangesNotifier = new PendingChangesNotifier(this, "value",  {warningTextString: this.pendingChangesWarningText});
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppJournalConfigEdit
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	},
	async beforeRouteLeave(to, from, next){
		if (!this.pendingChangesNotifier) {
			next();
			return;
		};
		let result = await this.pendingChangesNotifier.askToSave();
		if (result == ConfirmResult.CANCEL){
			return;
		}
		if (result == ConfirmResult.YES) {
			await this.save();
		}
		next();
	}
});
